import { render, staticRenderFns } from "./FINGERPRINT.vue?vue&type=template&id=4c994b6a"
import script from "./FINGERPRINT.vue?vue&type=script&lang=js"
export * from "./FINGERPRINT.vue?vue&type=script&lang=js"
import style0 from "./FINGERPRINT.vue?vue&type=style&index=0&id=4c994b6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports